import React from "react"
import { TheLine } from "./style"

const Line = ({ color, ...styleProps }) => {
  return <TheLine color={color} {...styleProps} />
}

export default Line
